import { create } from "zustand";

/**
 * What a "Report" tap is about (docs/features/reports.md). Any surface (the
 * venue detail, an offer card, the Offers-tab popup, the sidebar's own row)
 * calls `requestReport`; the page that owns the account sidebar listens to
 * `nonce` and opens it on the report view, which reads `target`.
 */
export interface ReportTarget {
  kind: "app" | "venue";
  restaurantId?: string;
  restaurantName?: string;
  offerId?: string;
  offerInfo?: string;
}

interface ReportState {
  target: ReportTarget;
  /** Bumped on every request, so the same target twice still re-opens. */
  nonce: number;
  requestReport: (target: ReportTarget) => void;
  setTarget: (target: ReportTarget) => void;
}

export const useReportStore = create<ReportState>((set) => ({
  target: { kind: "app" },
  nonce: 0,
  requestReport: (target) => set((s) => ({ target, nonce: s.nonce + 1 })),
  setTarget: (target) => set({ target }),
}));
